/* eslint react/require-default-props: off */
import React from 'react';
import PropTypes from 'prop-types';
import {
  QuietButton,
  Image,
  genesisStyled,
  css,
} from '@leagueplatform/genesis-commons';
import { useIntl } from '@leagueplatform/locales';
import BackIcon from '#assets/back.svg';

const BackButton = genesisStyled(QuietButton)(
  css({
    '&:hover, &:active, &:focus': {
      background: 'transparent !important',
      transform: 'translateX(-3px)',
      '&:dir(rtl)': {
        transform: 'translateX(3px)',
      },
    },
  }),
);

const Icon = genesisStyled(Image)(
  css({
    display: 'block',
    width: 24,
    height: 24,
    '&:dir(rtl)': {
      transform: 'rotateY(180deg)',
    },
  }),
);

export const BackButtonArrow = ({ onClick, ...props }) => {
  const { formatMessage } = useIntl();

  return (
    <BackButton
      onClick={onClick}
      backgroundColor="transparent"
      height="two"
      minWidth="two"
      paddingX="none"
      paddingY="none"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <Icon src={BackIcon} alt={formatMessage({ id: 'GO_BACK' })} />
    </BackButton>
  );
};

BackButtonArrow.propTypes = {
  onClick: PropTypes.func,
};
// Optional since postToWR is no longer mandatory
